var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E1F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.75C31.7279 18.75 34.75 21.7721 34.75 25.5V35.25H21.25V25.5C21.25 21.7721 24.2721 18.75 28 18.75Z",
    stroke: "#030C21",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 35.5V25.5C21 21.634 24.134 18.5 28 18.5C31.866 18.5 35 21.634 35 25.5V35.5M18 35.5H38",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38.5C29.3807 38.5 30.5 37.3807 30.5 36V35.5H25.5V36C25.5 37.3807 26.6193 38.5 28 38.5Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.a9aad679.svg";
export { ForwardRef as ReactComponent };